document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fg-section').forEach(function (section) {
    var wrapper = section.querySelector('.fg-wrapper');
    var track = section.querySelector('.fg-track');
    var toggleButtons = section.querySelectorAll('.fg-toggle-btn');
    var prevArrow = section.querySelector('.fg-arrow-prev');
    var nextArrow = section.querySelector('.fg-arrow-next');

    toggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-view');
        wrapper.classList.remove('fg-view-grid', 'fg-view-carousel');
        wrapper.classList.add('fg-view-' + view);

        toggleButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        track.scrollBy({ left: -280, behavior: 'smooth' });
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        track.scrollBy({ left: 280, behavior: 'smooth' });
      });
    }

    function addToCart(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || 'Could not add this item to your cart.');
          }
          return data;
        });
      });
    }

    section.querySelectorAll('.fg-add-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var idInput = form.querySelector('input[name="id"]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        var submitBtn = form.querySelector('button[type="submit"]');
        if (!idInput) return;

        var originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        addToCart(idInput.value, qtyInput ? qtyInput.value : 1)
          .then(function () {
            if (submitBtn) submitBtn.textContent = 'Added';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.error(err);
            alert(err.message || 'Could not add this item to your cart.');
            if (submitBtn) {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }
          });
      });
    });
  });
});